<div data-e2e="expand-arrow" class="d-flex flex-row">
  <fa-icon
    class="mr-1 align-self-start pre-pack-toggle-icon"
    [icon]="['fas', 'angle-down']"
    [class.rotated]="opened"
  ></fa-icon>

  <div
    class="d-flex flex-column prepack-title mr-1"
    [class.one-line]="oneLineHeader"
    data-e2e="pre-pack-title"
  >
    <strong [atxTooltip]="prepack?.title" [tooltipEnabled]="oneLineHeader">{{
      prepack?.title
    }}</strong>
    <span data-e2e="total-items-in-pre-pack" class="text-muted">
      {{ totalItemsInPrepactText }}
    </span>
    <div class="d-block d-md-none">
      <ng-container [ngTemplateOutlet]="lowInventoryWarning"></ng-container>
    </div>
  </div>
</div>

<div class="pre-pack-row-item d-flex align-items-center mr-auto pl-2">
  <div class="mr-md-3">
    <div
      class="thumbnails d-flex justify-content-sm-start"
      *ngIf="thumbnailsVisible"
    >
      <div
        *ngFor="
          let variant of prepack?.variants | slice: 0:numberOfImagesToDisplay;
          let first = first
        "
        class="position-relative"
      >
        <atx-image
          class="mr-1 mr-md-3 variant-img"
          data-e2e="pre-pack-variant-thumbnail"
          [imageUrl]="variant.mainImageUrl"
          [maxWidth]="imageMaxSizes.AVATAR"
          failedLoadIconSize="1x"
          (click)="clickMaterialImage(variant.productId, $event)"
        ></atx-image>
        <epc-never-out-of-stock-icon
          *ngIf="variant.neverOutOfStockType && first && showNoosIcon"
          class="pt-0 pl-0"
          [iconSize]="NeverOutOfStockIconSize.SMALL"
          [type]="variant.neverOutOfStockType"
        ></epc-never-out-of-stock-icon>
      </div>
    </div>
    <div class="d-none d-md-block text-left">
      <ng-container [ngTemplateOutlet]="lowInventoryWarning"></ng-container>
    </div>
  </div>
</div>

<ng-template #lowInventoryWarning>
  <span
    class="text-warning"
    *ngIf="quantityLeft <= quantityWarningThreshold"
    data-e2e="pre-pack-quantity-warning"
    >{{ lowInvetoryWarningText }}</span
  >
</ng-template>
